import React from "react";
import {InputEx} from "@components/wrapperComponents/InputEx";
import css from "../pannelloGiornataPLUS.module.css"
import cssFlex from '../comps/LogFlex.module.css'
import classNames from "classnames";
import {Flex, ScartiFlexCalcolo} from "@commons/services/presenze_calcolo/sub_calcolo/Flex";

export type FieldType = keyof Pick<Flex, 'scartiPrima' | 'scartiDopo'>;

interface TimbratureProps {
    fieldName: FieldType | 'scartiOrdinati' | 'effettiveFlex',
    showLabels?: boolean,
    labelRowTimbrature: string,
}

const inputCleaveOptions = {
    number: true, blocks: [2, 2],
    delimiter: ':', timeFormat: '24'
};

interface FlexForm extends Flex {

}

const LogFlex: React.FC<TimbratureProps> = ({fieldName, showLabels = true, labelRowTimbrature,}) => {
    /*const {control} = useForm<FlexForm>({});*/
    /*const {fields} = useFieldArray({
        name: fieldName, control, rules: {validate: () => true}
    });
*/
    const isItColorable = fieldName === 'scartiPrima' || fieldName === 'scartiDopo' /*|| fieldName === 'scartiOrdinati'*/

    const getInputStyle = function (scartiFLex: ScartiFlexCalcolo): string {
        const flexNegativa = ScartiFlexCalcolo.getSegnoScarto(scartiFLex) === -1 ? cssFlex.flexNegativa : '';
        const overflowFlex = /*overflow === true*/ false ? cssFlex.flexNegativaOverflow : '';
        const flexPositiva = ScartiFlexCalcolo.getSegnoScarto(scartiFLex) === 1 ? cssFlex.flexPositiva : '';

        return `${flexNegativa} ${overflowFlex} ${flexPositiva}`;
    }

    return <div className={classNames(css.gridTimbrature, css.grid4Timbrature)}>
        <div className="col-span-2 md:col-span-2 items-center font-semibold text-elemPresenze content-center truncate">{labelRowTimbrature}</div>
        <div className="grid grid-cols-subgrid col-span-2 gap-x-1 lg:gap-x-2 md:col-span-6 lg:col-span-8">
            {[0, 1, 2, 3].map((field, index) => {

                const inputEntrata = <>
                    {showLabels && <label className="md:text-xs 2xl:text-sm mb-0">{`${index + 1}° entrata`}</label>}
                    <input disabled={true} type="text"
                           value={!(fieldName === 'scartiOrdinati') ? ScartiFlexCalcolo.getScarto({} as ScartiFlexCalcolo) : ScartiFlexCalcolo.getScarti({} as ScartiFlexCalcolo)}
                           className={`h-8 my-1 sm:mb-0 ${isItColorable && getInputStyle({} as ScartiFlexCalcolo)}
                    appearance-none block w-full px-3 border rounded read-only:opacity-70 read-only:bg-sky-100 read-only:text-gray-900 shadow-sm sm:text-sm`}
                    />
                </>

                const inputUscita = <>
                    {showLabels && <label className="md:text-xs 2xl:text-sm mb-0">{`${index + 1}° uscita`}</label>}
                    <input disabled={true} type="text"
                           value={!(fieldName === 'scartiOrdinati') ? ScartiFlexCalcolo.getScarto({} as ScartiFlexCalcolo) : ScartiFlexCalcolo.getScarti({} as ScartiFlexCalcolo)}
                           className={`h-8 my-1 sm:mb-0 ${isItColorable && getInputStyle({} as ScartiFlexCalcolo)}
                    appearance-none block w-full px-3 border rounded read-only:opacity-70 read-only:bg-sky-100 read-only:text-gray-900 shadow-sm sm:text-sm`}
                    />
                </>

                /*const inputEntrataOld = <InputCleave<FlexForm>
                                    className={`h-8 my-1 sm:mb-0 ${isItColorable && getInputStyle({} as ScartiFlexCalcolo)}`}
                                    label={showLabels ? `${index + 1}° entrata` : ''}
                                    labelClassName="md:text-xs 2xl:text-sm mb-0"
                                    name={`${fieldName}`}
                                    disabled={true}
                                    control={control}
                                    options={/!*fieldName==='effettiveFlex'?inputCleaveOptions:*!/{}}
                                />*/

                /*const inputUscita = <InputCleave<Flex>
                    className={`h-8 my-1 sm:mb-0 ${isItColorable && getInputStyle({} as ScartiFlexCalcolo)}`}
                    label={showLabels ? `${index + 1}° uscita` : ''}
                    labelClassName="md:text-xs 2xl:text-sm mb-0"
                    name={`${fieldName}`}
                    disabled={true}
                    control={control}
                    options={/!*fieldName==='effettiveFlex'?inputCleaveOptions:*!/{}}
                    style={(isItColorable && {backgroundColor: '#df1fd9'}) || {}}
                />*/

                return <div key={index} className="grid grid-cols-subgrid col-span-2">
                    <div>
                        <InputEx input={inputEntrata} name="stub" addOnContainerClass="items-end"/>
                    </div>
                    <div>
                        <InputEx input={inputUscita} name="stub" addOnContainerClass="items-end"/>
                    </div>
                </div>
            })}
        </div>
    </div>
}

export default LogFlex;